import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['agreeAndCloseBtn']

  enableAgreeAndCloseBtn(e) {
    const isConfirmCheckboxChecked = e.target.checked
    if (isConfirmCheckboxChecked) {
      this.agreeAndCloseBtnTarget.removeAttribute('disabled')
    } else {
      this.agreeAndCloseBtnTarget.setAttribute('disabled', 'disabled')
    }
  }
}
